import { cn } from "@/lib/utils";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { LoadingState, ErrorState, EmptyState } from "./States";

/**
 * Dense data table.
 * columns: [{ key, header, render?(row), className?, headClassName?, align?: 'right', width? }]
 */
export const DataTable = ({ columns, rows, isLoading, error, onRetry, onRowClick, rowKey = (r) => r.id, empty, testId = "data-table", rowTestId, className, stickyHeader = true, maxHeight, footer, rowClassName }) => {
  return (
    <div className={cn("overflow-hidden rounded-md border bg-card", className)} data-testid={testId}>
      <div className={cn("overflow-auto scrollbar-thin", maxHeight)} style={maxHeight ? { maxHeight } : undefined}>
        <Table>
          <TableHeader className={cn(stickyHeader && "sticky top-0 z-10 bg-card")}>
            <TableRow className="border-b hover:bg-transparent">
              {columns.map((c) => (
                <TableHead key={c.key} className={cn("h-9 whitespace-nowrap px-3 text-[12px] font-medium text-muted-foreground", c.align === "right" && "text-right", c.headClassName)} style={c.width ? { width: c.width } : undefined}>
                  {c.header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading && (
              <TableRow className="hover:bg-transparent">
                <TableCell colSpan={columns.length}>
                  <LoadingState className="py-10" />
                </TableCell>
              </TableRow>
            )}
            {!isLoading && error && (
              <TableRow className="hover:bg-transparent">
                <TableCell colSpan={columns.length}>
                  <ErrorState error={error} onRetry={onRetry} className="py-10" />
                </TableCell>
              </TableRow>
            )}
            {!isLoading && !error && rows?.length === 0 && (
              <TableRow className="hover:bg-transparent">
                <TableCell colSpan={columns.length}>{typeof empty === "string" ? <EmptyState title={empty} /> : empty || <EmptyState />}</TableCell>
              </TableRow>
            )}
            {!isLoading &&
              !error &&
              rows?.map((r, i) => (
                <TableRow
                  key={rowKey(r) ?? i}
                  data-testid={rowTestId ? rowTestId(r) : undefined}
                  onClick={onRowClick ? () => onRowClick(r) : undefined}
                  className={cn("border-b border-border/70 last:border-b-0 transition-colors duration-100", onRowClick ? "cursor-pointer hover:bg-muted/50" : "hover:bg-transparent", rowClassName?.(r))}
                >
                  {columns.map((c) => (
                    <TableCell key={c.key} className={cn("px-3 py-2 align-middle text-[13px] leading-5", c.align === "right" && "text-right tabular", c.className)}>
                      {c.render ? c.render(r) : r[c.key] ?? <span className="text-muted-foreground">–</span>}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      {footer && <div className="border-t px-3 py-2 text-[12px] text-muted-foreground">{footer}</div>}
    </div>
  );
};
